import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { ValidationErrorResponse } from "../../requests/@types/response";
import api from "../../services/api";
import {
  UserClassificationFormValues,
  UserClassificationUpdateResponse
} from "./@types";

export const useSetBulkCloudMutation = (sampleHashes: Array<string>) =>
  useMutation<
    AxiosResponse<UserClassificationUpdateResponse>,
    AxiosError<ValidationErrorResponse>,
    UserClassificationFormValues
  >({
    mutationFn: (data: UserClassificationFormValues) =>
      api.setUserBulkCloudClassification({ hashValues: sampleHashes, data })
  });

export const useDeleteBulkCloudMutation = (sampleHashes: Array<string>) =>
  useMutation<
    AxiosResponse<UserClassificationUpdateResponse>,
    AxiosError<ValidationErrorResponse>
  >({
    mutationFn: () =>
      api.deleteUserBulkCloudClassification({ hashValues: sampleHashes })
  });

export const useSetBulkLocalMutation = (sampleHashes: Array<string>) =>
  useMutation<
    AxiosResponse<UserClassificationUpdateResponse>,
    AxiosError<ValidationErrorResponse>,
    UserClassificationFormValues
  >({
    mutationFn: (data: UserClassificationFormValues) =>
      api.setBulkUserClassification({ hashValues: sampleHashes, data })
  });

export const useDeleteBulkLocalMutation = (sampleHashes: Array<string>) =>
  useMutation<
    AxiosResponse<UserClassificationUpdateResponse>,
    AxiosError<ValidationErrorResponse>
  >({
    mutationFn: () =>
      api.deleteBulkUserClassification({ hashValues: sampleHashes })
  });
